
import { FloatingLabel, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';

import useExperienciaDocente from "../hooks/useExperienciaDocente"
import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';
// import { formatearFecha } from '../functions/formatearFecha';
// import { yearActual } from '../functions/fechaMenos18';

const ExperienciaDocente = () => {


    const { isOpen, abrirModal, cerrarModal, guardarExp, setformExpDocente,
        formExpDocente, expDocente, valorAnterior,
        llenarFormExpDocente, cargando, borrarExp } = useExperienciaDocente();


    return (
        <div className="my-4">
            <hr className='m-5'/>
                <p className="lead text-center">
                    Experiencia como docente
                </p>

                <Button variant="info" onClick={ abrirModal }>
                    Agregar experiencia
                </Button>

                <div className='table-responsive my-4'>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th className='text-center'>Inicio</th>
                                <th className='text-center'>Final</th>
                                <th className='text-center'>Institución</th>
                                <th className='text-center'>Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            { expDocente.map(( e, i )=> (
                                <tr key={ i }>
                                    <td className='text-center'>
                                        { e.inicio }
                                    </td>
                                    <td className='text-center'>
                                        { e.final }
                                    </td>
                                    <td className='text-center'>
                                        { e.empresa }
                                    </td>
                                    <td className='text-center'>
                                        <ButtonGroup>
                                            <TooltipHover tooltipText='Editar información'>
                                                <Button variant='warning' onClick={ () => llenarFormExpDocente( e ) }>
                                                    <PencilIcon/>
                                                </Button>
                                            </TooltipHover>
                                            <TooltipHover tooltipText='Eliminar'>
                                                <Button variant='danger' onClick={ () => borrarExp( e.pk_exp ) }>
                                                    <DeleteIcon/>
                                                </Button>
                                            </TooltipHover>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>




                <Modal
                    show={ isOpen }
                    onHide={ cerrarModal }
                    backdrop="static"
                    keyboard={false}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    className=''
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Administrar registros</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Alert variant='success'>
                            Indique la fecha aproximada y el lugar donde trabajó como docente.<br/>
                        </Alert>

                        <Row>
                            <Col xs={12} xl={6}>
								{ formExpDocente.inicio ? 'Valor anterior: ' + valorAnterior.inicio : null }
                                <FloatingLabel
                                    controlId="floatingInput3"
                                    label="Año de inicio"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formExpDocente.inicio }
                                        onChange={ e => setformExpDocente({ ...formExpDocente, inicio: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
								{ formExpDocente.final ? 'Valor anterior: ' + valorAnterior.final : null }
                                <FloatingLabel
                                    controlId="floatingInput3"
                                    label="Año de finalización"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formExpDocente.final }
                                        onChange={ e => setformExpDocente({ ...formExpDocente, final: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput3"
                                    label="Institución educativa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formExpDocente.empresa }
                                        onChange={ e => setformExpDocente({ ...formExpDocente, empresa: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                        </Row>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={ cerrarModal }>
                            Cerrar
                        </Button>
                        <Button variant="primary" onClick={ guardarExp } disabled={ cargando }>
                            { ( cargando ) ? "Guardando" : "Guardar cambios" }
                        </Button>
                    </Modal.Footer>
                </Modal>
            <hr className='m-5'/>
        </div>
    )
}

export default ExperienciaDocente
